/*============================================================================
Ajax the add to cart experience by revealing it in a side drawer
Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
(c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

This file includes:
- Basic Shopify Ajax API calls
- Ajax cart plugin

This requires:
- jQuery 1.8+
- handlebars.min.js (for cart template)
- modernizer.min.js
- snippet/ajax-cart-template.liquid

Customized version of Shopify's jQuery API
(c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

MODIFIED: Now works with LSC side cart for instant updates
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

function leafiCleanAjaxProductTitle(title, type, handle) {
  if (window.leafiCleanProductTitle) {
    return window.leafiCleanProductTitle(title, type, handle);
  }

  var fallbackProductType = String(type || '');
  var fallbackProductHandle = String(handle || '');
  var fallbackRaw = String(title || '').replace(/\s+/g, ' ').trim();
  var fallbackWork = fallbackRaw
    .replace(/Ã¢â‚¬â€œ|Ã¢â‚¬â€/g, ' - ')
    .replace(/[\u2013\u2014]/g, ' - ')
    .replace(/\s*(?:\||I)\s*LEAFI Aroma(?: UAE)?\s*$/i, '')
    .replace(/\s+-\s*LEAFI Aroma(?: UAE)?\s*$/i, '')
    .replace(/\s*LEAFI Aroma(?: UAE)?\s*$/i, '')
    .trim();
  var fallbackContext = (fallbackProductType + ' ' + fallbackWork + ' ' + fallbackProductHandle).toLowerCase();
  var fallbackBase = fallbackWork.split('|')[0].split(' I ')[0].trim();
  var fallbackPrefix = fallbackBase.split(/\s+-\s+/)[0].trim() || fallbackBase;
  var fallbackCleanPrefix = function(pattern) {
    return fallbackPrefix.replace(pattern, '').replace(/\s+/g, ' ').trim();
  };

  if (fallbackContext.indexOf('x-air') > -1) return 'LEAFI X-AIR Car Aroma Diffuser';
  if (fallbackContext.indexOf('y-air') > -1) return 'LEAFI Y-AIR Car Aroma Diffuser';
  if (fallbackContext.indexOf('z-air') > -1) return 'LEAFI Z-AIR Car Aroma Diffuser';
  if (fallbackContext.indexOf('aura 100') > -1 || fallbackContext.indexOf('aura-100') > -1) return 'LEAFI Aura 100 Smart Aroma Diffuser';
  if (fallbackContext.indexOf('aura 200') > -1 || fallbackContext.indexOf('aura-200') > -1) return 'LEAFI Aura 200 Smart Aroma Diffuser';
  if (fallbackContext.indexOf('aura 300') > -1 || fallbackContext.indexOf('aura-300') > -1) return 'LEAFI Aura 300 Smart Aroma Diffuser';
  if (fallbackContext.indexOf('reed diffuser') > -1 || fallbackContext.indexOf('reed-diffuser') > -1) return fallbackCleanPrefix(/luxury reed diffuser|reed diffuser/ig) + ' Reed Diffuser';
  if (fallbackContext.indexOf('room spray') > -1 || fallbackContext.indexOf('room-spray') > -1) return fallbackCleanPrefix(/luxury room spray|room spray/ig) + ' Room Spray';
  if (fallbackContext.indexOf('fragrance oil') > -1 || fallbackContext.indexOf('essential oil') > -1 || fallbackContext.indexOf(' oil') > -1) return fallbackCleanPrefix(/fragrance oil|essential oil/ig) + ' Fragrance Oil';
  if (fallbackContext.indexOf('candle') > -1 || fallbackContext.indexOf('soy wax') > -1) return fallbackCleanPrefix(/soy wax candle|candle/ig) + ' Candle';

  return fallbackWork.replace(/\s+\|\s+/g, ' ').replace(/\s+I\s+/g, ' ').replace(/\s+/g, ' ').trim();

  var raw = String(title || '').replace(/\s+/g, ' ').trim();
  var work = raw
    .replace(/Ã¢â‚¬â€œ|Ã¢â‚¬â€/g, '-')
    .replace(/[–—]/g, ' - ')
    .replace(/\s*(?:\||I)\s*LEAFI Aroma(?: UAE)?\s*$/i, '')
    .replace(/\s*LEAFI Aroma(?: UAE)?\s*$/i, '')
    .trim();
  var productType = String(type || '');
  var productHandle = String(handle || '');
  var context = (productType + ' ' + work + ' ' + productHandle).toLowerCase();
  var base = work.split('|')[0].split(' I ')[0].split(/\s+-\s+/)[0].trim();
  var cleanBase = function(pattern) {
    return base.replace(pattern, '').replace(/\s+/g, ' ').trim();
  };

  if (context.indexOf('x-air') > -1) return 'LEAFI X-AIR Car Aroma Diffuser';
  if (context.indexOf('y-air') > -1) return 'LEAFI Y-AIR Car Aroma Diffuser';
  if (context.indexOf('z-air') > -1) return 'LEAFI Z-AIR Car Aroma Diffuser';
  if (context.indexOf('aura 100') > -1 || context.indexOf('aura-100') > -1) return 'LEAFI Aura 100 Smart Aroma Diffuser';
  if (context.indexOf('aura 200') > -1 || context.indexOf('aura-200') > -1) return 'LEAFI Aura 200 Smart Aroma Diffuser';
  if (context.indexOf('aura 300') > -1 || context.indexOf('aura-300') > -1) return 'LEAFI Aura 300 Smart Aroma Diffuser';
  if (context.indexOf('reed diffuser') > -1 || context.indexOf('reed-diffuser') > -1) return cleanBase(/reed diffuser/ig) + ' Reed Diffuser';
  if (context.indexOf('room spray') > -1 || context.indexOf('room-spray') > -1) return cleanBase(/room spray/ig) + ' Room Spray';
  if (context.indexOf('fragrance oil') > -1 || context.indexOf('essential oil') > -1) return cleanBase(/fragrance oil|essential oil/ig) + ' Fragrance Oil';
  if (context.indexOf('candle') > -1 || context.indexOf('soy wax') > -1) return cleanBase(/soy wax candle|candle/ig) + ' Candle';

  return work.replace(/\s+\|\s+/g, ' ').replace(/\s+I\s+/g, ' ').replace(/\s+/g, ' ').trim();
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.parseErrorResponse = function(XMLHttpRequest) {
  try {
    return JSON.parse(XMLHttpRequest.responseText || '{}');
  } catch (e) {
    return {};
  }
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = ShopifyAPI.parseErrorResponse(XMLHttpRequest);
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : 'CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

itemAddedCallback = function (product) {
$addToCart.removeClass('is-adding').addClass('is-added');

ShopifyAPI.getCart(cartUpdateCallback);

// ALSO trigger LSC side cart update if available
if (window.LSC && LSC.quickLoad) {
LSC.quickLoad();
}
// Dispatch event for any other listeners
document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: product }));
};

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = ShopifyAPI.parseErrorResponse(XMLHttpRequest);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.product-add');
        $('<div/>', { class: 'errors qty-error' }).text(data.description || data.message).insertBefore($addButtoncontainer);
      }
    }
  };

cartUpdateCallback = function (cart) {
// Update quantity and price
updateCountPrice(cart);
buildCart(cart);

// ALSO sync with LSC side cart if available
if (window.LSC && LSC.render) {
LSC.render(cart);
}
// Dispatch event for any other listeners
document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
};

  buildCart = function(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="cart-content"> Your cart is currently empty. <a class="dt-sc-btn" href="">Continue Shopping</a></p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = Shopify.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = Shopify.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
        }
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: leafiCleanAjaxProductTitle(cartItem.product_title, cartItem.product_type, cartItem.handle || cartItem.url),
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0
    };

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

cartCallback = function(cart) {
$body.removeClass('drawer--is-loading');
$body.trigger('ajaxCart.afterCartLoad', cart);

if (window.Shopify && Shopify.StorefrontExpressButtons) {
Shopify.StorefrontExpressButtons.initialize();
}

// ALSO sync with LSC side cart if available
if (window.LSC && LSC.render) {
LSC.render(cart);
}
};

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    
    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),      
          qty = parseInt($qtySelector.val());      
          if (!isNaN(qty)) {
            var qty = validateQty(qty); 
          }
          else
          {
            qty = 0;
          }

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));
